import { VendorStateLabels } from 'src/pages/Vendors/vendors.constants'
import { FilterBarConfig } from '../../../FilterBar.constants'
import { FilterName, FilterParam } from '../../../FilterBar.types'

// The Vendor Health dashboard shows active vendors until the state filter says otherwise.
export const VENDOR_HEALTH_DEFAULT_STATES: string[] = [VendorStateLabels.ACTIVE]

export type DashboardDimensionFilter = {
  filterParam: FilterParam
  filterName: FilterName
  dimension: string
  // Label of the option selecting points without the dimension.
  undefinedString?: string
  defaultSelection?: string[]
}

// Filter bar keys whose options are a dashboard dimension's values.
export const DASHBOARD_DIMENSION_FILTERS: Partial<
  Record<keyof FilterBarConfig, DashboardDimensionFilter>
> = {
  dashboardVendorState: {
    filterParam: FilterParam.DASHBOARD_VENDOR_STATE,
    filterName: FilterName.VENDOR_STATE,
    dimension: 'lifecycle_state',
    defaultSelection: VENDOR_HEALTH_DEFAULT_STATES,
  },
  dashboardVendorStatus: {
    filterParam: FilterParam.DASHBOARD_VENDOR_STATUS,
    filterName: FilterName.VENDOR_STATUS,
    dimension: 'vendor_status',
  },
  dashboardVendorName: {
    filterParam: FilterParam.DASHBOARD_VENDOR_NAME,
    filterName: FilterName.DASHBOARD_VENDOR,
    dimension: 'vendor_name',
  },
  dashboardRiskTier: {
    filterParam: FilterParam.DASHBOARD_RISK_TIER,
    filterName: FilterName.RISK_TIER,
    dimension: 'risk_tier',
  },
  dashboardVendorOwner: {
    filterParam: FilterParam.DASHBOARD_OWNER,
    filterName: FilterName.DASHBOARD_OWNER,
    dimension: 'owner',
    undefinedString: 'Unassigned',
  },
  dashboardAssignee: {
    filterParam: FilterParam.DASHBOARD_ASSIGNEE,
    filterName: FilterName.ASSIGNEE,
    dimension: 'assignees',
    undefinedString: 'Unassigned',
  },
}
